<ul role="tablist" class="tab" *ngIf="customUseCasesVisible">
    <li role="tab" aria-selected="true" aria-controls="panel-1" id="tab-1" class="tablinks"
        [attr.aria-label]="('ONBOARDING.CONSENT_USE_CASE.PREDEFINED_USE_CASE' | translate) + ('SCREEN_READER.TAB_BUTTON' | translate)"
        [tabIndex]="1"
        [ngClass]="step === 1 ? 'active' : 'basic'"
        (click)="selectTab(1)"
        (keyup)="onKeyUp($event, 1)">
        {{'ONBOARDING.CONSENT_USE_CASE.PREDEFINED_USE_CASE' | translate}}
    </li>
    <li role="tab" aria-selected="false" aria-controls="panel-2" id="tab-2" class="tablinks"
        [attr.aria-label]="('ONBOARDING.CONSENT_USE_CASE.CUSTOM_USE_CASES' | translate) + ('SCREEN_READER.TAB_BUTTON' | translate)"
        [tabIndex]="1"
        [ngClass]="step === 2 ? 'active' : 'basic'"
        (click)="selectTab(2)"
        (keyup)="onKeyUp($event, 2)">
        {{'ONBOARDING.CONSENT_USE_CASE.CUSTOM_USE_CASES' | translate}}
    </li>
</ul>
<app-predefined-use-cases *ngIf="step == 1"
                          [consentUseCases]="predefinedUseCases"
                          (useCaseStepEvent)="useCaseStepEvent.emit($event)">
</app-predefined-use-cases>
<app-custom-use-cases *ngIf="step == 2"
                      (myUseCaseEvent)="myUseCaseEvent.emit(customUseCase)">
</app-custom-use-cases>
